import React, { useEffect, useState } from "react";
import { Container, Card, CardBody, Badge, Spinner } from "reactstrap";
import Handler from "../Helpers/Handler";

const STATUS_COLOR = {
  placed: "warning",
  preparing: "info",
  delivered: "success",
  cancelled: "danger",
  on_the_way: "secondary"
};

const OrderHistory = () => {

  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [customer, setCustomer] = useState(null);

  useEffect(() => { loadOrders(); }, []);

  const loadOrders = async () => {
    try {
      const res = await Handler({
        method: "post",
        url: "/delivery_status/order_history.php"
      });

      if (res?.success) {
        setCustomer({
          name: res.data.customer_name,
          mobile: res.data.customer_mobile,
          email: res.data.customer_email
        });
        setOrders(res.data.order_history || []);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <Container className="order-wrapper mt-3 mb-4">

      {/* ---------- PROFILE ---------- */}
      {customer && (
        <Card className="profile-card mb-4 border-0 shadow-sm">
          <CardBody className="py-3 px-4 d-flex align-items-center gap-3">

            <div className="profile-avatar">
              <i className="bx bx-user fs-4"></i>
            </div>

            <div className="flex-grow-1">
              <div className="profile-name">{customer.name}</div>

              <div className="profile-sub mt-1">
                <i className="bx bx-phone"></i> {customer.mobile}
              </div>

              <div className="profile-sub">
                <i className="bx bx-envelope"></i> {customer.email}
              </div>
            </div>

          </CardBody>
        </Card>
      )}

      {/* ---------- ORDERS ---------- */}
      {orders.length === 0 ? (
        <p className="text-center text-muted mt-5">No orders found</p>
      ) : (
        orders.map(order => (
          <Card key={order.order_id} className="order-card mb-3 border-0 shadow-sm">
            <CardBody className="py-2">

              {/* HEADER */}
              <div className="d-flex justify-content-between align-items-center mb-1">
                <div>
                  <div className="fw-semibold">Order #{order.order_id}</div>
                  <div className="text-muted small">{order.created_at}</div>
                </div>

                <Badge
                  pill
                  color={STATUS_COLOR[order.delivery_status] || "secondary"}
                  className="status-badge px-2 py-1 text-uppercase"
                >
                  {order.delivery_status}
                </Badge>
              </div>

              {/* ITEMS */}
              {order.items.map((item, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center item-row"
                >
                  <div className="item-name">
                    {item.product_name}
                    <span className="text-muted"> × {item.qty}</span>
                  </div>
                  <div className="fw-semibold small">₹ {item.subtotal}</div>
                </div>
              ))}

              {/* TOTAL */}
              <div className="d-flex justify-content-between align-items-center mt-2 total-row">
                <div className="fw-semibold small">Total</div>
                <div className="fw-bold text-primary">₹ {order.total}</div>
              </div>

              {/* META */}
              <div className="meta-row mt-2">
                <div>
                  <i className="bx bx-wallet"></i> {order.payment_method}
                </div>
                <div>
                  <i className="bx bx-home"></i> {order.order_type}
                </div>
              </div>

              {/* DELIVERY ADDRESS (NEW) */}
              {order.delivery_address && (
                <div className="address-row mt-2">
                  <i className="bx bx-map"></i>
                  <span>{order.delivery_address}</span>
                </div>
              )}

            </CardBody>
          </Card>
        ))
      )}

    </Container>
  );
};

export default OrderHistory;
